import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { ModalModule } from 'ngx-bootstrap';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TShirtsFormsComponent } from './t-shirts-forms/t-shirts-forms.component';
import { TShirtsFormsService } from './t-shirts-forms/t-shirts-forms.service';
import { PaymentCompletedComponent } from './payment-completed/payment-completed.component';

import { CarouselModule } from 'ngx-bootstrap/carousel';

@NgModule({
  declarations: [
    AppComponent,
    TShirtsFormsComponent,
    PaymentCompletedComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    HttpClientModule,
    CarouselModule.forRoot(),
    ModalModule.forRoot()
  ],
  providers: [
    TShirtsFormsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
